import { AbstractCommand } from 'src/models/command';

class DeleteAppointmentTimerFavoriteCommand extends AbstractCommand {
	readonly name = 'IFS_Calendar_Command_Commands_DeleteAppointmentTimerFavorite';
	readonly processId = 'random';

	public constructor(id: number) {
		super();

		this.parameters = {
			id: id,
		};
	}
}

export { DeleteAppointmentTimerFavoriteCommand };
